module.exports = __webpack_public_path__ + "media/images/admin/icons/file-text-cb094fae8eba3fdd4b841eca5f2c4d44.svg";